const CONSUMPTION_TAXONOMY_ID = '-4';
const CUSTOM_TAXONOMY_ID = 'custom';
const DISCOVER_TAXONOMY_ID = 'digger';
const FUSION_GWI_TAXONOMY_ID = '-5';
const FUSION_WWGWI_MED_TAXONOMY_ID = '-8';
const FUSION_TGI_TAXONOMY_ID = '-6';

export const FUSION_TAXONOMY_IDS = [
  FUSION_GWI_TAXONOMY_ID,
  FUSION_WWGWI_MED_TAXONOMY_ID,
  FUSION_TGI_TAXONOMY_ID,
] as const;

const MRI_SIMMONS_TAXONOMY_IDS = [
  'consumption_psychographics',
  'psychographic_mri_simmons',
] as const;

const TGI_PSYCHOGRAPHIC_TAXONOMY_IDS = [
  'tgi_psychographics',
  'psychographic_tgi',
] as const;

const GWI_PSYCHOGRAPHIC_TAXONOMY_IDS = [
  'gwi_psychographics',
  'psychographic_gwi',
  'ww_gwi_med_psychographics',
  'wwgwimed_psychographics',
  'wwgwi_psychographics',
] as const;

const FUSION_PSYCHOGRAPHIC_TAXONOMY_IDS = [
  ...MRI_SIMMONS_TAXONOMY_IDS,
  ...TGI_PSYCHOGRAPHIC_TAXONOMY_IDS,
  ...GWI_PSYCHOGRAPHIC_TAXONOMY_IDS,
] as const;

const FUSION_PSYCHOGRAPHIC_ID_PREFIXES = [
  'consumption_',
  'mdf24_',
  'mdf25_',
  'tgb2212_',
  'tgb2605_',
  'gwi_',
  'gwi23q4_',
  'gwi26q1_',
  'gwiusa24q4_',
  'gwiusa25q4_',
  'gwim23q4_',
  'gwim24q4_',
] as const;

export const TRIAL_DISABLED_TAXONOMY_IDS = new Set<string>([
  CONSUMPTION_TAXONOMY_ID,
  DISCOVER_TAXONOMY_ID,
  CUSTOM_TAXONOMY_ID,
  ...FUSION_TAXONOMY_IDS,
  ...FUSION_PSYCHOGRAPHIC_TAXONOMY_IDS,
]);

interface TrialTaxonomyNode {
  id?: string;
  parent_id?: string | null;
}

const FUSION_PSYCHOGRAPHIC_PARENT_IDS = new Set<string>(
  FUSION_PSYCHOGRAPHIC_TAXONOMY_IDS
);

export const isTrialDisabledTaxonomyNode = (
  item: TrialTaxonomyNode | null | undefined,
  isTrial: boolean
): boolean => {
  if (!isTrial || !item?.id) return false;
  if (TRIAL_DISABLED_TAXONOMY_IDS.has(item.id)) return true;
  if (item.parent_id && FUSION_PSYCHOGRAPHIC_PARENT_IDS.has(item.parent_id))
    return true;

  return FUSION_PSYCHOGRAPHIC_ID_PREFIXES.some((prefix) =>
    item.id?.startsWith(prefix)
  );
};
